<template>
    <div>
        <van-grid :border="false" :column-num="3">
            <van-grid-item v-for="(ele,index) in data" :key="index">
              <div class="num-wrapper" >
                <p class="num-p">{{commafy(ele.value)}}</p>
                <p class="ins-p">{{ele.text}}</p>
              </div>
            </van-grid-item>
          </van-grid>
    </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
import { numFormat } from "@/mixins/NumFormat.js";
export default {
    name: "periodAmount",
  components: {
  },
  props:{
    timeRange:{
      style:Number,
      default:7
    }
},
mixins: [numFormat],
  data() {
    return {
      active: 0,
      data:[]
    };
  },
  computed: {},
  methods: {
    link: function(value) {
      location.href = "/" + value;
    },
    getQuantity() {
      this.$axios
        .post(this.$url + "/statistics", {
          userToken: userToken,
          askData: "periodAmount",
          timeRange:this.timeRange
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.data = response.data.res_record;
          } else {
            this.$toast(response.data.error_info);
          }
        })
        .catch(error => {
          this.$toast("网络无法连接或" + error);
        });
    }
  },
  created() {
      this.getQuantity();
  }
    
}
</script>
<style scoped>

.num-wrapper {
  text-align: center;
}

.num-p {
  font-size: 0.8rem;
}

.ins-p {
  font-size: 0.5rem;
  color: #999;
  padding: 0.5rem 0;
}

</style>